/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Vue, Component, Prop } from 'vue-property-decorator';
import ButtonBar from '../button-bar';

const style = require('./index.module.scss');

export enum ResultPageStatusEnum {
  PROCESS = 'process', // 申请处理中
  SUCCESS = 'success', // 成功
  FAIL = 'fail', // 失败，通常指服务代码层面异常
  REJECT = 'reject', // 拒绝，通常指业务逻辑上的拒绝
}

@Component
export default class ResultPage extends Vue {
  // 申请操作实时状态
  @Prop(String) readonly status!: ResultPageStatusEnum;

  // 标题（对应显示的操作名称以及结果，如：提现成功）
  @Prop({
    type: [String, Object],
  })
  readonly title!: string;

  // 副标题（对状态标题的辅助说明信息）
  @Prop({
    type: [String, Object, Array],
  })
  readonly subTitle?: string | string[];

  // 是否展示实际放款金额
  @Prop({ type: Boolean, default: false })
  readonly isLentOrPayoff!: boolean;

  // 页面操作按钮设置
  @Prop(String) readonly cancelButtonText?: string;

  @Prop(String) readonly confirmButtonText?: string;

  // 展示渠道图标
  @Prop(String) readonly productIcon?: string;

  // 金额
  @Prop(String) readonly amount?: string;

  // 还款记录
  // TODO: 临时解决方案
  @Prop({ default: false })
  readonly isVisibleRepayText!: boolean

  // 是否新版底部按钮样式
  @Prop({ default: false })
  readonly isNewBtnType!: boolean

  // 支持多行显示副标题内容
  private get subTitleRaws(): string[] {
    if (Array.isArray(this.subTitle)) {
      return this.subTitle;
    }

    return typeof this.subTitle !== 'undefined' ? [this.subTitle] : [];
  }

  // 是否有自定义内容模块
  private get hasContent(): boolean {
    return !!this.$slots.default;
  }

  private get hasButtons(): boolean {
    return !!(this.cancelButtonText || this.confirmButtonText);
  }

  // 获取金额文本,如果是否是LENT&PAYOFF状态,则显示实际放款金额,否则显示借款金额
  private get amountText(): string {
    if (this.isVisibleRepayText) {
      return '还款金额(元)';
    }
    return this.isLentOrPayoff ? '实际放款金额(元)' : '借款金额(元)';
  }

  private render() {
    return (
      <div class={[style.container]}>
        <div class={[style.header, this.amount && style.applyHeader]}>
          <div class={style.mainIcon}>
            <span
              class={[
                style.statusIcon,
                this.productIcon && style.amountIcon,
                !this.productIcon && style[`statusIcon_${this.status}`],
              ]}
              style={
                this.productIcon && {
                  backgroundImage: `url(${this.productIcon})`,
                }
              }
            />
          </div>

          {this.amount && (
            <div class={style.moneyText}>
              <div class={this.isLentOrPayoff ? style.amountText : ''}>
                {this.amountText}
              </div>
              <div class={style.amount}>{Number(this.amount).toFixed(2)}</div>
            </div>
          )}

          <p
            class={[
              style.title,
              this.amount && style.amountTitle,
              style[`title_${this.status}`],
            ]}
          >
            {this.title}
          </p>

          {this.subTitleRaws.map((subTitlte) => (
            <p class={style.subTitle}>{subTitlte}</p>
          ))}
        </div>

        {this.hasContent && (
          <div class={style.content}>{this.$slots.default}</div>
        )}

        {this.hasButtons && (
          <div class={[style.footer, this.amount && style.applyFooter]}>
            <ButtonBar
              noBorder
              cancelText={this.cancelButtonText}
              confirmText={this.confirmButtonText}
              onCancel={this.onCancel.bind(this)}
              onConfirm={this.onConfirm.bind(this)}
              isNewBtnType={this.isNewBtnType}
            />
          </div>
        )}
      </div>
    );
  }

  private onCancel() {
    this.$emit('cancel');
  }

  private onConfirm() {
    this.$emit('confirm');
  }
}
